<button
  [attr.title]="'PROMPTS_DIALOG.VIEW_PROMPTS' | translate"
  class="flex justify-center items-center h-10 popup-button"
  (click)="showDialog()"
>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M7.5013 17.5001C7.5013 17.9584 7.8763 18.3334 8.33464 18.3334H11.668C12.1263 18.3334 12.5013 17.9584 12.5013 17.5001V16.6667H7.5013V17.5001ZM10.0013 1.66675C6.78464 1.66675 4.16797 4.28341 4.16797 7.50008C4.16797 9.48342 5.15964 11.2251 6.66797 12.2834V14.1667C6.66797 14.6251 7.04297 15.0001 7.5013 15.0001H12.5013C12.9596 15.0001 13.3346 14.6251 13.3346 14.1667V12.2834C14.843 11.2251 15.8346 9.48342 15.8346 7.50008C15.8346 4.28341 13.218 1.66675 10.0013 1.66675ZM12.3763 10.9167L11.668 11.4167V13.3334H8.33464V11.4167L7.6263 10.9167C6.5013 10.1334 5.83464 8.85842 5.83464 7.50008C5.83464 5.20008 7.7013 3.33341 10.0013 3.33341C12.3013 3.33341 14.168 5.20008 14.168 7.50008C14.168 8.85842 13.5013 10.1334 12.3763 10.9167Z"
      fill="#475569"
    />
  </svg>
</button>
<p-dialog [header]="'PROMPTS_DIALOG.VIEW_PROMPTS' | translate" [modal]="true" [(visible)]="visible">
  <div class="chat-default-prompts grid grid-cols-2 gap-1.5 text-xs">
    @if (prompts.length > 0) {
      @for (prompt of prompts; track prompt) {
        <aiops-prompt-block [prompt]="prompt" (click)="closeDialog()"></aiops-prompt-block>
      }
    }
  </div>
</p-dialog>
